export const setLoading = ( state, value ) => {
    state.isLoading = value;
}

export const clearStateStore = ( state ) => {
    state.isLoading = false;
}
